import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    confirm: 'Decline this quote',
    description:
      'You are about to archive this quote, it will appear as "declined". You can find it at any time by clicking on the "Declined" filter.',
    errorMessage:
      'An error occurred while declining your quote. Please try again in a few minutes and don’t hesitate to contact us if the error remains.',
    successMessage: 'Your quote n°{0} has been marked as declined!',
    title: 'Mark this quote as declined',
  },
  fr: {
    cancel: 'Annuler',
    confirm: 'Refuser le devis',
    description:
      'Vous vous apprêtez à archiver ce devis, il apparaîtra comme “refusé”. Vous pourrez le retrouver à tout moment en cliquant sur le filtre "Refusés”.',
    errorMessage:
      'Une erreur est survenue lors de l’archivage de votre devis. Essayez à nouveau dans quelques minutes et n’hésitez pas à nous contacter si le problème persiste.',
    successMessage: 'Votre devis n°{0} a bien été refusé\xA0!',
    title: 'Marquez ce devis comme refusé',
  },
} as const);
